// status: updated
import { Images } from "@assets/assets";
import { PortfolioAllListInterface } from "@/lib/Types";
export const PROJECTS: PortfolioAllListInterface[] = [
  {
    id: 1,
    title: "AllProColor",
    description:
      "AllProColor is an online platform connecting professional interpreters with businesses all around the world. AllProColor helps users to hire language specialists who can do the most accurate interpretation at affordable costs, with no middlemen involved.",
    categories: [
      { name: "Enterprise" },
      { name: "E-commerce" },
      { name: "On-Demand Interpretation" },
    ],
    image: Images?.portfolio.portfolio1,
    colspan: 2,
  },
  {
    id: 2,
    title: "Oyraa",
    description:
      "Oyraa is an online platform connecting professional interpreters with businesses all around the world. Oyraa helps users to hire language specialists who can do the most accurate interpretation at affordable costs, with no middlemen involved.",
    categories: [
      { name: "Enterprise" },
      { name: "E-commerce" },
      { name: "On-Demand Interpretation" },
    ],
    image: Images?.portfolio.portfolio2,
    colspan: 1,
  },
];
